import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
const NewsModal = ({ homeDoc, setShow, show }) => {
    const [userEmail, setEmail] = useState(null)
    const [userName, setName] = useState(null)
    const handleSubscrbe = (e) => {
        e.preventDefault();
        if (!userEmail || !userName) {
            return toast.error(`Please enter your ${!userEmail ? "email address" : "Name"}`)
        }
        const loading = toast.loading('Please wait...!');
        axios.post("https://guarded-wave-53446.herokuapp.com/newsletter", { email: userEmail, name: userName })
            .then(res => {
                toast.dismiss(loading);
                if (res.data) {
                    toast.success('Successfully received!')
                    setShow(false)
                }
            })
            .catch(error => {
                toast.error("something went wrong. please try again")
            });
    }
    return (
        < >
            <Modal
                show={show}
                centered
                onHide={() => setShow(false)}
                className=" "
                dialogClassName="newsletter "
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header className=" cross-btn" closeButton>
                </Modal.Header>
                <Modal.Body className=" ">
                    <div className="news-details-body  ">
                        <h5 className="text-center pt-2 pb-3">{homeDoc?.newsletter_title}</h5>
                        <p>{homeDoc?.newsletter_des}</p>
                        <div className=" pt-3 ">
                            <form className="d-block">
                                <input onBlur={(e) => setName(e.target.value)}
                                    type="text"
                                    className="form-control email-btn "
                                    placeholder="Enter your name..."
                                    aria-describedby="emailHelp"
                                />
                                <input onBlur={(e) => setEmail(e.target.value)}
                                    type="email"
                                    className="form-control email-btn "
                                    id="exampleInputEmail1"
                                    placeholder="Enter your email..."
                                    aria-describedby="emailHelp"
                                />
                                <button
                                    onClick={(e) => handleSubscrbe(e)}
                                    className="subscribe-btn"
                                >{homeDoc?.newsletter_btn_text}</button>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default NewsModal;